import { API } from "@/services"

export const SERVER_GROUPS_ENDPOINTS = {
  create(data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/groups`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/groups`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/groups/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/groups/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/groups/${id}`,
      method: 'PUT',
      data,
    })
  },
}